// extracted by mini-css-extract-plugin
export default {"section":"styles_section__HvWtF","gridExt":"styles_gridExt__AsjbX"};